import React from 'react';
import Home from '../Home/Home/Home';

const LocationRouter = () => {
  // Simply show the home page - no location detection on landing
  return <Home />;
};

export default LocationRouter;
